import { Icon } from "@circle-react-shared/Icon";
import debounce from "lodash/debounce";
import { useCallback } from "react";

import { t } from "@/i18n-js/instance";

interface DebouncedSearchBarProps {
  defaultValue?: string;
  onSearch: (value: string) => void;
  placeholder?: string;
  wait?: number;
  withIcon?: boolean;
}

export const DebouncedSearchBar = ({
  defaultValue = "",
  onSearch,
  placeholder = t("search_item"),
  wait = 300,
  withIcon = true,
}: DebouncedSearchBarProps) => {
  const debouncedSearch = useCallback(
    debounce((value: string) => onSearch(value), wait),
    [onSearch, wait],
  );

  return (
    <label className="m-0 flex flex-1 items-center gap-1">
      {withIcon && (
        <Icon className="text-dark inline-block" type="16-search" size={16} />
      )}
      <input
        className="bg-primary text-dark placeholder:text-light w-full px-2 py-1 placeholder:opacity-100 focus:outline-none"
        defaultValue={defaultValue}
        placeholder={placeholder}
        onChange={event => debouncedSearch(event.target.value)}
        onKeyDown={event => {
          if (event.key === "Enter") {
            event.preventDefault();
            event.stopPropagation();
          }
        }}
      />
    </label>
  );
};
